export default function () {
    return {
        DEFAULT: 'DEFAULT',
        PRIKE: 'PRIKE'
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/review/layout/index.js